export default __webpack_public_path__ + "static/media/akar-icon.22805afc.svg";